import { z } from "zod";

/**
 * A console session of a server (`POST /projects/:projectId/servers/:serverId/console`):
 * where the browser opens its VNC WebSocket, on our own origin, and the VNC
 * password when the server asks for one. Valid for one connection, briefly.
 */
export const ConsoleSession = z.object({
  /** Path of the WebSocket on our origin, e.g. `/api/v1/console/<ticket>`. */
  url: z.string().startsWith("/"),
  password: z.string().nullable(),
});
export type ConsoleSession = z.infer<typeof ConsoleSession>;
